const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const conchitaFactory = require('components/conchita/js/main');
const manageMyBookingModule = require('od-modules/manage_my_booking/manage_my_booking');
const {preloadMmbBase} = require('components/user_area/booking_info/mmb.preload');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const getFrontendBookingManagement = () => import('@edreamsodigeo/frontend-booking-management');
const {openChat, closeChat, initChat} = require('od-modules/chat/chat_script');
const myTripsFactory = require('components/user_area/my_trips/js/main');

let loaded = false;
const componentByPage = {
    contact: 'standaloneContactUsFlow',
    categories: 'standaloneContactUsFlow',
};

Odigeo.Router.handlers['support-center'] = (params) => {
    if (loaded) {
        return;
    }
    const widgetLoader = createWidgetLoader({
        conchita: ['conchita', conchitaFactory],
        myTrips: ['openmytrips', myTripsFactory],
    });
    const bookingInfo = manageMyBookingModule.getBookingInfo();
    preloadMmbBase();

    Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
        {
            globalEvents: {},
            viewEvents: {
                'conchita:MMB:goToAutoCheckin': 'goToAutoCheckin',
                'conchita:MMB:goToTripdetails': 'goToTripdetails',
                'conchita:MMB:goToManageMyBooking': 'goToManageMyBooking',
            },
            eventHandlers: {
                goToAutoCheckin: () => {
                    Odigeo.Router.navigate('tripdetails', {params: 'showProduct=true;product=checkIn'});
                },
                goToTripdetails: () => {
                    Odigeo.Router.navigate('tripdetails');
                },
                goToManageMyBooking: () => {
                    Odigeo.Router.navigate('tripdetails');
                    widgetLoader.get('myTrips').execute('navigateToNewMMB');
                },
            },
        });

    Odigeo.Router.eventController.execute();

    loaded = true;
    Odigeo.on('routeChange', function isMmbInternalNavigation({from, to}) {
        if (from.name.includes('support-center') !== to.name.includes('support-center')) {
            loaded = false;
            Odigeo.off('routeChange', isMmbInternalNavigation);
            getFrontendBookingManagement().then((bookingManagement) => {
                const containers = document.querySelectorAll('.conchita.conchita-container');
                containers.forEach((element) => bookingManagement.unmountComponentAtNode(element));
            });
        }
    });

    websiteConfigCollection.getLoadedPromise().then(() => {
        getFrontendBookingManagement().then((bookingManagement) => {
            widgetLoader.get('conchita')
                .execute('load', {
                    identifier: 'conchita-support-center',
                    container: 'conchita-support-center',
                    component: bookingManagement[componentByPage[params.replace(/[^\w\s]/gi, '')]],
                    translationPath: '/secure/translations/mmb',
                    data: {
                        bookingInfo,
                        openChat: openChat,
                        closeChat: closeChat,
                    },
                    conchitaLiveContent: true,
                    module: 'mmb',
                    basePath: '/',
                }).then(initChat());
        });
    });
};

